/** Shared scroll-reveal for home page sections */

export const homeScrollViewport = {
  once: true,
  amount: 0.15,
  margin: '0px 0px -5% 0px',
};

export const homeScrollStagger = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.08, delayChildren: 0.04 },
  },
};

export const homeScrollItem = {
  hidden: { opacity: 0, y: 28 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.55, ease: [0.22, 1, 0.36, 1] },
  },
};
